export default __webpack_public_path__ + "static/media/H0004.c5faac28.png";